import * as React from 'react';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat, SeatPricing, SeatZone } from '../../classes/seat';
import isMobile from '../../helpers/is-mobile';

import * as isEqual from 'react-fast-compare';

declare var Modernizr: any;

interface ISeatPathProps {
    key: string;
    seat: Seat;
    selectedSeat: Seat;
    dispatch: any;
    levelPricing: Array<SeatZone>;
    selectedPriceTypes: Array<PriceType>;
    lowerPrice: number;
    upperPrice: number;
    mouseOverSeat: (Seats, xPos, yPos) => any;
    mouseOutSeat: (Seats) => any;
    mapDragging: boolean;
    cartSeats: Array<CartSeat>;
    seatHovered: boolean;
    isTest?: boolean;
}

enum SeatHoverPosition {
    TopLeft,
    TopRight,
    BottomLeft,
    BottomRight
}

class SeatPath extends React.Component<ISeatPathProps, any>{
    constructor(props: ISeatPathProps) {
        super(props);
    }

    shouldComponentUpdate(nextProps: ISeatPathProps, nextState) {
        if (nextProps.mapDragging) {
            return false;
        }
        if (nextProps.isTest != null && nextProps.isTest) {
            return true;
        }
        return !isEqual(this.props, nextProps);
    }

    private getSelectedPrices(props: ISeatPathProps) {
        let seatZone = parseInt(props.seat.tessituraSeat.zoneId);
        let matchedZone = props.levelPricing.filter(levelPricing => levelPricing.zoneId === seatZone);

        if (matchedZone.length > 0 && matchedZone[0].prices.length > 0) {
            //this means the user did not pick any filters, so no need to match on selected filters
            if (props.selectedPriceTypes.length === 0) {
                return matchedZone[0].prices;
            }
            return matchedZone[0].prices.filter(price => props.selectedPriceTypes.some(selectedPriceType => selectedPriceType.priceTypeId === price.priceTypeId));
        } else {
            return [];
        }
    }

    private isInPriceRange(): boolean {
        if (this.getSelectedPrices(this.props).length > 0) {
            return this.getSelectedPrices(this.props).some(price => price.price >= this.props.lowerPrice && price.price <= this.props.upperPrice);

        } else {
            return false;
        }
    }

    private doesApplyPriceTypeFilter(): boolean {
        return this.props.selectedPriceTypes.length > 0
            ? this.props.selectedPriceTypes.some(pt => this.getSelectedPrices(this.props).map(price => price.priceTypeId).indexOf(pt.priceTypeId) >= 0)
            : true;
    }

    render() {
        var currentSeatStyle = this.props.seat.seatStyle;
        //if the current seat is in the cart
        const seatDisabled = this.props.seat.tessituraSeat.isAvailable && this.props.seat.tessituraSeat.isDisabled;

        var selectedSeat = this.props.selectedSeat != null ? this.props.selectedSeat.seatId === this.props.seat.seatId : false;

        var seatFill = selectedSeat ? this.props.seat.seatStyle.svgSelectedFill : this.props.seat.seatStyle.svgDefaultFill;
        seatFill = this.props.seatHovered && (!seatDisabled)
            && (this.props.seat.tessituraSeat.isAvailable || (this.props.seat.seatStyleCulture.fullPrompt != null && this.props.seat.seatStyleCulture.fullPrompt.length > 0))
            && !isMobile() ? this.props.seat.seatStyle.svgHoverFill : seatFill;

        let hasHoverText = (this.props.seat.seatStyleCulture.smallPrompt !== null && this.props.seat.seatStyleCulture.smallPrompt.length > 0)
            || (this.props.seat.tessituraSeat.isAvailable && this.props.seat.seatingOptionGroup != null && this.props.seat.seatingOptionGroup.unlockSeatingOptionGroupId != null);

        let hasPromptText = (this.props.seat.seatStyleCulture.fullPrompt !== null && this.props.seat.seatStyleCulture.fullPrompt.length > 0);

        let isAvailableText = (!this.props.seat.tessituraSeat.isAvailable ? " is-unavailable" : "");
        let disableCriterMismatchFading = (this.props.seat.tessituraSeat.isAvailable && !selectedSeat && !this.props.seat.suggestedSeat);

        return (
            <path id={'seat-' + this.props.seat.seatId} data-seat-id={this.props.seat.seatId} key={this.props.seat.seatId} d={this.props.seat.activeSvgPath} fill={seatFill}
                strokeWidth={this.props.seat.seatStyle.svgStrokeWidth}
                stroke={this.props.seat.seatStyle.svgStrokeColor}
                className={isAvailableText + ((disableCriterMismatchFading && (!this.props.seat.matchesCriteria
                    || !this.isInPriceRange() || !this.doesApplyPriceTypeFilter())) ? " criteria-mismatch" : "")
                    + (hasPromptText ? " has-prompt" : (hasHoverText ? " has-hover" : ""))
                    + " seat-path-js seat-path"}
                onMouseOver={(e) => {
                    //if (!this.props.mapDragging) {
                    let svgPath = e.currentTarget.getBoundingClientRect();
                    let mouseCordsX = e.pageX;
                    let mouseCordsY = e.pageY;
                    this.props.mouseOverSeat([this.props.seat], mouseCordsX, mouseCordsY);
                    //this.props.mouseOverSeat([this.props.seat], svgPath.left + (svgPath.width / 2), svgPath.top + (svgPath.height / 2));
                    //}
                }}
                onMouseOut={(e) => {
                    //if (!this.props.mapDragging) {
                    this.props.mouseOutSeat([this.props.seat])
                    //}
                }} />
        );
    }


}

export default SeatPath;